var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1109 13.5754C17.5014 13.9659 18.1346 13.9659 18.5251 13.5754L21 11.1005C23.1479 8.95265 23.1479 5.47025 21 3.32236C18.8521 1.17448 15.3697 1.17448 13.2218 3.32236L10.7469 5.79724C10.3564 6.18776 10.3564 6.82093 10.7469 7.21145C11.1375 7.60197 11.7706 7.60197 12.1612 7.21145L14.636 4.73658C16.0029 3.36974 18.2189 3.36974 19.5858 4.73658C20.9526 6.10341 20.9526 8.31949 19.5858 9.68632L17.1109 12.1612C16.7204 12.5517 16.7204 13.1849 17.1109 13.5754Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79719 10.747C6.18771 10.3565 6.82088 10.3565 7.2114 10.747C7.60193 11.1375 7.60193 11.7707 7.2114 12.1612L4.73653 14.6361C3.36969 16.0029 3.36969 18.219 4.73653 19.5858C6.10336 20.9527 8.31944 20.9527 9.68628 19.5858L12.1612 17.1109C12.5517 16.7204 13.1848 16.7204 13.5754 17.1109C13.9659 17.5015 13.9659 18.1346 13.5754 18.5252L11.1005 21C8.95261 23.1479 5.4702 23.1479 3.32232 21C1.17443 18.8521 1.17443 15.3697 3.32232 13.2219L5.79719 10.747Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97917 15.3432C8.58865 14.9527 8.58865 14.3195 8.97917 13.929L13.9289 8.97922C14.3194 8.58869 14.9526 8.58869 15.3431 8.97922C15.7337 9.36974 15.7337 10.0029 15.3431 10.3934L10.3934 15.3432C10.0029 15.7337 9.3697 15.7337 8.97917 15.3432Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLink);
export default __webpack_public_path__ + "static/media/create-link.061c1b2a201d6338bf550ff02b45db3f.svg";
export { ForwardRef as ReactComponent };